/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M5 4.5h14c1.933 0 3.5 1.567 3.5 3.5v8c0 1.933-1.567 3.5-3.5 3.5H5c-1.933 0-3.5-1.567-3.5-3.5V8c0-1.933 1.567-3.5 3.5-3.5ZM0 8c0-2.7614 2.2386-5 5-5h14c2.7614 0 5 2.2386 5 5v8c0 2.7614-2.2386 5-5 5H5c-2.7614 0-5-2.2386-5-5V8Zm6 3.5h12a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1ZM4 12c0-1.1046.8954-2 2-2h12c1.1046 0 2 .8954 2 2s-.8954 2-2 2H6c-1.1046 0-2-.8954-2-2Z"
    clipRule="evenodd"
  />,
  'Port'
);
